
import { Component, Prop, Mixins, Ref } from "vue-property-decorator";
import { SmartText } from "_components";
import { onView, onScroll, onResize } from "_mixins";
import { mapAnimation, clamp, lerp } from "_utils";

@Component({
  name: "HomeHeroHeadline",
  components: { SmartText },
})
export default class HomeHeroHeadline extends Mixins(
  onView,
  onScroll,
  onResize
) {
  @Prop({ required: true, type: String }) rootClass: string;
  @Prop({ required: true, type: Array }) headline: [string, string];

  @Ref() topLine;
  @Ref() bottomLine;
  @Ref() measure: HTMLElement;
  @Ref() wrapper: HTMLElement;

  toplineCache = 0;
  bottomLineCache = 0;

  measurements = { scrollStart: 0, scrollEnd: 0, top: 0, bottom: 0 };

  mounted() {
    this.calc();
  }

  onResize() {
    this.calc();
  }

  calc() {
    this.measurements = {
      scrollStart: 0,
      scrollEnd: this.wrapper.offsetHeight + this.wrapper.offsetTop,
      top: this.measure.offsetWidth - this.topLine.$el.offsetWidth,
      bottom: this.measure.offsetWidth - this.bottomLine.$el.offsetWidth,
    };
  }

  createAnimationStyle(limit: number, scroll: number) {
    const { scrollStart, scrollEnd } = this.measurements;
    return clamp(
      mapAnimation([scrollStart, scrollEnd], [0, limit], scroll),
      0,
      limit
    );
  }

  onScroll(scroll: number) {
    if (this.isInView) {
      const { top, bottom } = this.measurements;
      const topTarget = this.createAnimationStyle(top, scroll);
      const topLerp = lerp(this.toplineCache, topTarget);
      const bottomTarget = this.createAnimationStyle(bottom, scroll);
      const bottomLerp = lerp(this.bottomLineCache, bottomTarget);
      this.topLine.$el.style.transform = `translateX(-${topLerp}px)`;
      this.bottomLine.$el.style.transform = `translateX(${bottomLerp}px)`;
      this.toplineCache = topLerp;
      this.bottomLineCache = bottomLerp;
    }
  }
}
